<template>
  <div
    class="card-3"
    :style="{
      'background': config.background,
      'border-radius': config.isRadio ? '5px' : 0,
      fontFamily:config.fontFamily?config.fontFamily:'auto',
    }"
  >
    <div
      v-if="config.title.show"
      class="opacity-08 card-3-title"
      :style="{
        lineHeight: config.title.lineHeight+'px',
        color: config.title.color,
        fontSize: config.title.fontSize + 'px',
        marginLeft: config.title.offsetX + 'px',
      }"
    >
      {{ config.title.text }}
    </div>
    <div
      class="m-count opacity-08"
      :style="{
        color: config.count.color,
        fontSize: config.count.fontSize + 'px',
        marginLeft: config.count.offsetX + 'px',
        margin:arrayToPx(config.count.margin),
        fontWeight:config.count.fontWeight
      }"
    >
      {{ getCount }}{{ config.count.company }}
    </div>
    <div
      class="wrap opacity-08"
      :class="[`${config.subitem.display === 'block'?'block-wrap':'flex-wrap'}`]"
      :style="{
        color: config.subitem.color,
        display:config.subitem.display
      }"
    >
      <div class="item" v-if="config.subitem1.show">
        <div
          class="name"
          :style="{
            fontSize: config.subitem.fontSizeName+ 'px'
          }"
        >
          <!-- {{ chartData[0][config['t1Field']] }} -->
          {{ config.subitem1.text }}
        </div>
        <div
          class="count"
          :style="{
            fontSize: config.subitem.fontSizeCount+ 'px',
            marginLeft:config.subitem.offsetX+ 'px'
          }"
          :class="[parseFloat(chartData[0][config['c1Field']]) < 0 ? 'green' : 'red']"
        >
          {{ numberSplitWithComma(chartData[0][config['c1Field']]) }}
        </div>
      </div>
      <div
        class="item"
        v-if="config.subitem2.show"
        :style="{
          ...itemBotStyleMargin(config.subitem.display,config.subitem.subitemGap)
        }"
      >
        <div
          class="name"
          :style="{
            fontSize: config.subitem.fontSizeName+ 'px'
          }"
        >
          <!-- {{ chartData[0][config['t2Field']] }} -->
          {{ config.subitem2.text }}
        </div>
        <div
          class="count"
          :style="{
            fontSize: config.subitem.fontSizeCount+ 'px',
            marginLeft:config.subitem.offsetX+ 'px'
          }"
          :class="[parseFloat(chartData[0][config['c2Field']]) < 0 ? 'green' : 'red']"
        >
          {{ numberSplitWithComma(chartData[0][config['c2Field']]) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common.js'
export default {
  name: 'CardThree',
  mixins: [common],
  props: {
    config: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    chartData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    getCount () {
      return this.config.count.thousandthPercent ? this.numberSplitWithComma(this.chartData[0][this.config['cField']]) : this.chartData[0][this.config['cField']]
    }
  },
  created () {},
  mounted () {},
  watch: {},
  methods: {
    arrayToPx (array = []) {
      return array.map(item => {
        return `${item}px`
      }).join(' ')
    },
    itemBotStyleMargin (val = 'flex', gap = 10) {
      let marginTopOrLeft = val === 'block' ? '0' : '3'
      let marginVal = [0, 0, 0, 0]
      marginVal[marginTopOrLeft] = gap ?? 0
      return {
        margin: this.arrayToPx(marginVal)
      }
    }
  },
  components: {}
}
</script>

<style scoped lang="stylus">
.card-3 {
  color: #fff;
  height 100%
}

.wrap
  display: flex
  .item
    display: flex
    align-items center
    .count
      margin-left: 10px
    .red
      color: #FF326C;
    .green
      color: #87D10A;
.flex-wrap
  .item+.item
    margin-left: 20px

.m-count {
  margin: 15px 0 10px 0;
}

</style>
